// import './LoadingOverlay.css';
import { __ } from '@wordpress/i18n';
import styles from './LoadingOverlay.module.css';

const LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className={`${styles['hvnly-settings-api__overlay']} ${styles['active']}`}>
      <div className={styles['loader-container']}>
        <div className={styles['dot-pulse']}></div>
        <div className={styles['loader-text']}>{__('Processing your request', 'havenlytics')}</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;